import { Card } from '../../ui'
import { partnershipData } from './data'
import styles from './PartnershipPage.module.css'

export function QuotaMeter() {
  return (
    <div className={styles.quotaScope} data-scope="quota-meter">
      <Card>
        <div className={styles.cardHead}>
          <h3>{partnershipData.quotaTitle}</h3>
          <span className={styles.cardSubtitle}>{partnershipData.copy.quotaPeriod}</span>
        </div>
        <div className={styles.cardBody}>
          <div className={styles.quotaValues}>
            <span>{partnershipData.copy.quotaUsedLabel}</span>
            <span className="mono-num" data-role="quota-value">{partnershipData.quotaValue}</span>
          </div>
          <div className={styles.quotaTrack}>
            <div
              className={styles.quotaBar}
              data-role="quota-bar"
              style={{ width: `${partnershipData.current.usedRatio * 100}%` }}
            />
          </div>
          <div className={styles.quotaNote}>{partnershipData.quotaNote}</div>
        </div>
      </Card>
    </div>
  )
}
